import React from "react";
import TeamDivider from "./components/TeamDivider";

function App() {
  return (
    <div className="App">
      <TeamDivider />
    </div>
  );
}

export default App;
